import React from "react";
import Track from "./Track";
import { setParentTrackOpen } from "../redux/actions";
import { selectParentTrackOpen } from "../redux/selectors";
import { connect } from "react-redux";
class ParentTrack extends React.Component {
    render() {
        const { name } = this.props.track;

        return (
            <React.Fragment>
                <Track
                    type="jobpack"
                    name={name}
                    events={this.props.events.events}
                    parentTrackIndex={this.props.index}
                    childTrackIndex={false}
                    overlaps={this.props.events.overlaps}
                    setShowChildren={show => {
                        this.props.setParentTrackOpen(this.props.index, show);
                        this.setState({
                            showChildren: show
                        });
                    }}
                    showChildren={this.props.open}
                />
                {this.props.events.children &&
                    this.props.open &&
                    this.props.events.children.map((c, i) => {
                        return (
                            <Track
                                key={i}
                                type={c.type}
                                name={c.name}
                                events={c.events}
                                parentTrackIndex={this.props.index}
                                childTrackIndex={i}
                                overlaps={c.overlaps || 1}
                                setShowChildren={show => {
                                    this.props.setParentTrackOpen(
                                        this.props.parentTrackIndex,
                                        show
                                    );
                                    this.setState({
                                        showChildren: show
                                    });
                                }}
                            />
                        );
                    })}
            </React.Fragment>
        );
    }
}

export default connect(
    (store, props) => {
        return { open: selectParentTrackOpen(props.index)(store) };
    },
    { setParentTrackOpen }
)(ParentTrack);
